<template>
    <div class="app">
        <div class="searchBox">
            <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
            <div class="search">
                <input type="text" v-model.trim="keywords" placeholder="搜索商铺会员卡" maxlength="13">
                <img src="../../assets/images/searchIcon.png" @click="searchEvent" alt="">
            </div>
        </div>
        <div class="content">
            <div class="blank"></div>
            <div class="haveCard" v-if="!haveCard">
                <div class="cards">
                    <ul>
                        <li v-for="(value,index) in searchResult" :key="index" @click="goCardDetail(index)">
                            <div class="card">
                                <img src="../../assets/images/bg-one.jpg" alt="">
                                <div class="cardtext1">
                                    <img src="../../assets/images/systemIcon.png" alt="">
                                    <span>卡逸客PLUS会员</span>
                                    <div>{{value.cName}}</div>
                                </div>    
                                <div class="cardtext2">
                                    <span>{{value.zheKou}}折</span>
                                    <span>会员详情</span>
                                    <i class="el-icon-arrow-right"></i>
                                </div>
                                <div class="cardtext3">
                                    <span>共享会员卡</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { DatetimePicker, Popup, Toast, Indicator, Radio } from "mint-ui";
import axios from "axios";
import store from "@/vuex/store";
import { mapState } from "vuex"; 
import global from "../../../static/js/global";
import config from "../../../static/js/config";
export default {
  name: 'searchCard',
  data() {
    return {         
        haveCard:false,
        inputValue:'',
        keywords:'',
        cardArry:[],              // 会员卡列表信息 
        searchResult:[],
        // Toast: Toast({
        //     message: '加载中...',
        //     position: 'middle',
        //     duration: -1
        // }),
    };
  },
  computed: {},
  components: {
      
  },
  methods: {
        // 搜索事件
        searchEvent(){
            return this.searchResult = this.cardArry.filter(item => {
               if(item.cName.includes(this.keywords)){
                   return item;
               }
           })        
        },
      // 跳转到会员卡详情页面
      goCardDetail(index)
      {
          console.log('index',index);
          //var cardInfo = this.cardArray[index];
          this.$router.push(
            { 
              name:"cardDetail",
              query:
              {
                  index:index
              }
            });
      },
      checkHttpReturn(id)
      {
          if(httpSendQue[id]==0)
          {
              var  self=this;
              setTimeout(() => {
                      if (self && !self._isDestroyed)
                          self.checkHttpTimeOut();
                  }, newConfigTime);

          }
          else
          {
              delete httpSendQue[id];
          }
      },
      checkHttpTimeOut()
      {
          if(httpSendQue[id]==0)
          {
              //  隐藏加载中
                // this.Toast.close()
                Toast({
                      message: '网络不给力',
                      position: 'middle',
                      duration: 3000
                    })
                

          }
          else
          {
              //删除数组中的id
              delete httpSendQue[id];

          }
      },
      getMemberCardList()
      {
          var  self=this;     
          id= getHttpSendId ();
          getArry(id)   //将生成ID放入数组  
          setTimeout(() => 
          {
              if (self && !self._isDestroyed)
                  self.checkHttpReturn(id);
          }, configTime);      
          axios.get(cardList+"&uid="+uid+"&sign="+sign+"&mode="+mode)
          .then(res=>{
            
           // 5.接受到请求 改变id的值
            httpSendQue[id] = 1; 
            // this.Toast.close();
            if (res.data.s == 0) 
            {
                this.havaCard=true
                this.cardArry = res.data.cardList;
                console.log('cardList',this.cardArry);
                // vuex存储卡列表
                this.$store.commit("newslist", this.cardArry );
            }
            else if (res.data.s == 1010)
            {
                this.havaCard=false
            }

            if (res.data.isMessage == 1)
            {
                // this.haveMsg = true;
            } 
            else if (res.data.isMessage == 0)
            {
                // this.haveMsg = false;
            }
            
           })
           .catch(error=>{
                // httpSendQue[id] = 1;   
                // this.Toast.close()
                Toast({
                    message: '网络不给力',
                    position: 'middle',
                    duration:2000
                })
           })
                     
              
      }, 
      
  },

  mounted()
  {
      this.getMemberCardList();
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
.searchBox{
  height: 1.89rem;
  width: 100%;
  /* background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%); */
  position: fixed;
  top: 0;
  padding-top: 0.32rem;
  z-index: 1;
}
.searchBox :nth-child(1){
    font-size: 0.7rem;
    color: black;
    font-weight: 600;
    position: relative;
    top: 0.79rem;
    left: 0.2rem;
}
.search{
    width: 7.5rem;
    height: 1.26rem;
    line-height: 1.26rem;
    border-radius: 0.05rem;
    border: 0.03rem solid rgba(255, 255, 255, 1);
    box-shadow: 0 0.05rem 0.05rem 0 rgba(0, 0, 0, 0.24);
    background-color: rgba(250, 250, 250, 1);
    margin-left: 1.63rem;
    position: relative;
    top: -0.65rem;
}
.search :nth-child(2){
    width: 0.45rem;
    height: 0.45rem;
    position: absolute;
    top: 0.45rem;
    left: 6.79rem;
}
.search :nth-child(1){
    width: 6.16rem;
    height: 0.79rem;
    font-size: 0.37rem;
    font-weight: normal;
    border: none;
    position: absolute;
    top: 0.26rem;
    left: 0.24rem;
    
}
.blank {
  height: 2.11rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  font-size: 0.42rem;
  /* background-color: rgba(0, 0, 0, 0.1); */
  height: 100%;
  width: 100%;
}
.noCard{
    width: 100%;
    height: 84%;
    position: relative;
}
.noCard :nth-child(1){
    width: 3.42rem;
    height: 3.16rem;
    position: absolute;
    top: 0.67rem;
    left: 3.13rem;
}
.noCard :nth-child(2){
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 4.68rem;
    left: 2.08rem;
}
 .card{
    border: 0.03rem solid #ffffff;
    border-radius: 0.55rem;
    width: 8.24rem;
    height: 5.05rem;
    position: relative;
    left: 0.87rem;
    overflow: hidden;
    color: #ffffff;
}
.card :nth-child(1){
    width: 8.24rem;
    height: 5.05rem; 
    position: absolute; 
}
.cards ul li{
    position: relative;
    top: -3.5rem;
}
.cards ul :nth-child(1){
    position: relative;
    top: 0;
    z-index: 0;
}
.cards ul :nth-child(2){
    position: relative;
    top: -3.5rem;
    z-index: 1;
}
.cards ul :nth-child(3){
    position: relative;
    top: -7rem;
    z-index: 2;
}
.cards ul :nth-child(4){
    position: relative;
    top: -10.5rem;
    z-index: 4;
}
.cards ul :nth-child(5){
    position: relative;
    top: -14rem;
    z-index: 4;
}
.cards ul :nth-child(6){
    position: relative;
    top: -17.5rem;
    z-index: 4;
}
.cardtext1{
    position: absolute;
    top: -5rem !important;
}
.cardtext2{
    position: absolute;
    padding-left: 0.53rem;
    top: -3rem !important;
}
.cardtext3{
    position: absolute;
    padding-left: 0.53rem;
    top: -4.5rem !important;
}
.cardtext1 :nth-child(1){
    width: 1.2rem;
    height: 1.2rem;
    position: absolute;
    left: 0.43rem;
}
.cardtext1 :nth-child(2){
    font-size: 0.42rem;
    position: absolute;
    top: -0.45rem !important;
    left: 0.32rem;
}
.cardtext1 :nth-child(3){
    font-size: 0.32rem;
    text-align: right;
    position: absolute;
    top: -0.9rem !important;
    right: 0.53rem;
}
.cardtext2 :nth-child(1){
    font-size: 0.42rem;
    position: absolute;
}
.cardtext2 :nth-child(2){
    font-size: 0.42rem;
    position: absolute;
    top: 0rem !important;
    right: -4rem;
}
.cardtext2 :nth-child(3){
    font-size: 0.32rem;
    text-align: right;
    position: absolute;
    top: 0rem !important;
    right: -4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/cardBag/searchCard.vue